import { Button } from '@dixa/lib-shared-habla';
import { ampli } from 'lib-shared-tracking';
import { Company } from 'lib-shared-types-api';

// eslint-disable-next-line no-restricted-imports
import { actions as companyModalActions } from 'components/shared/companyModal/actions/companyModal';
import { useAppDispatch } from 'utils/redux/useAppDispatch';

import { ContactInfo } from '../../../contactInfo/contactInfo';

interface CompanyInfoCardProps {
  company: Company;
}

export function CompanyInfo({ company }: CompanyInfoCardProps): JSX.Element {
  const { name } = company;
  const primaryLabel = name;

  const dispatch = useAppDispatch();

  const handleEditCompany = () => {
    ampli.contactsCardEditCompanyClicked();
    dispatch(companyModalActions.companyModalShow({ company }));
  };

  const actions = (
    <Button icon="pen" variant="secondary" onClick={handleEditCompany}>
      Edit
    </Button>
  );

  return (
    <ContactInfo
      avatar={company}
      primaryLabel={primaryLabel}
      actions={actions}
    />
  );
}
